// extracted by mini-css-extract-plugin
export default {"innerWrapper":"iy-z","tooltipWrapper":"jy-z","icon":"ky-z","tooltip":"ly-z","content":"my-z"};